import React from 'react';

import { Variant as CloseIconVariant } from '@swf/components/StarsModal/components/CloseButton';
import type { ChestRewardMPNotification } from '@swf/core/types/Notification';

import type { CardViewProps } from '../../config/NotificationTypes';
import type { NotificationType } from '../../enums';
import SharedStyles from '../../styles/shared.scss';
import Attributes from '../Attributes/Attributes';
import Buttons, { GroupVariant as ButtonGroupVariant } from '../Buttons/Buttons';
import Description from '../CardDescription/CardDescription';
import ChestImageWrapper, { ChestImageVariant } from '../ChestImageWrapper/ChestImageWrapper';
import Header, { HeaderVariant } from '../Header/Header';
import Title from '../Title/Title';

interface CardDataProps {
  cardData: ChestRewardMPNotification;
}

/**
 * Default front card of a 'Chest notification'.
 */
const ChestRewardView: React.FC<CardViewProps & CardDataProps> = ({
  cardData: {
    title,
    type,
    description,
    attributes,
    notificationId,
    attributes: { metaData, customSkin, logoName },
    headerImageURL
  },
  viewConfig: {
    title: titleKey,
    description: descriptionKey,
    displayAttributes,
    actions,
    defaultHeaderImageURL,
    showCloseIcon
  },
  onClickClose,
  locale
}) => (
  <>
    <Header
      showCloseIcon={showCloseIcon}
      closeIconVariant={CloseIconVariant.Light}
      headerImageURL={headerImageURL}
      defaultHeaderImageURL={defaultHeaderImageURL}
      onClickClose={onClickClose}
      variant={HeaderVariant.Large}
    />
    <section className={SharedStyles.notificationBody}>
      <ChestImageWrapper
        cdnBase="https://starscrm.rationalcdn.com"
        type={type as NotificationType}
        metaData={metaData}
        logoName={logoName}
        customSkin={customSkin}
        variant={ChestImageVariant.Default}
      />
      <Title title={title} titleKey={titleKey} attributes={attributes} />
      <Description
        descriptionText={description}
        descriptionKey={descriptionKey}
        attributes={{ ...attributes }}
      />
      <Attributes displayAttributes={displayAttributes} attributes={attributes} locale={locale} />
      <Buttons
        actionList={actions}
        notificationType={type}
        attributes={attributes}
        notificationId={notificationId}
        secondaryVariant="text"
        groupVariant={ButtonGroupVariant.Stacked}
      />
    </section>
  </>
);

export default ChestRewardView;
